<!--
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-20 19:20:03
-->
<template>
  <div class="home-page page-container">
    <home-banner :datas="banners"></home-banner>
    <div class="content">
      <!-- 演讲 SWIPER START -->
      <div class="speech-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">演讲</div>
            <div class="subtitle">人文·科技·白日梦</div>
          </div>
          <div class="more_btn" @click="onClickMore('speech')">查看全部</div>
        </div>
        <div class="speech-swiper-bl">
          <swiper class="swiper" :options="speechSwiperOption" ref="speechSwiper" @click="onClickSpeechItem">
            <swiper-slide v-for="(list, index) in speechSwiperPages" :key="index">
              <div class="swiper-page">
                <div class="speech-item" v-for="item in list" :key="item.id" :data-id="item.id">
                  <div class="cover-wrap no-pointer-evts">
                    <img :src="item.cover" :alt="item.title" />
                    <div class="video_time">{{ item.time }}</div>
					<div class="memberTag" v-if="item.member_type == 2">会员专享</div>
                  </div>
                  <div class="video_intro-wrap no-pointer-evts">
                    <div class="video_intro--content">
                      <div class="video_title">{{ item.title }}</div>
                      <div class="speaker_intro-wrap">
                        <span class="speaker_name">{{ item.speaker.name }}</span>
                        <span class="speaker_intro">{{ item.speaker.intro }}</span>
                      </div>
                      <div class="video_intro">
                        {{ item.titlelanguage }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-btn-wrap"
            ref="speechSwiperBtns"
            :style="{ top: `${ssbsIndex * (SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP)}px` }"
          >
            <div class="speech swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="speech swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 演讲 SWIPER END -->

      <!-- 现场 SWIPER START -->
      <div class="activity-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">现场</div>
            <div class="subtitle">一席现场活动</div>
          </div>
          <div class="more_btn" @click="onClickMore('activity')">查看全部</div>
        </div>
        <div class="activity-swiper-bl">
          <swiper class="swiper" :options="activitySwiperOption" @click="onClickActivityItem">
            <swiper-slide v-for="item in activitySwiperItems" :key="item.id">
              <div class="activity-item" :data-id="item.id">
                <div class="cover-wrap no-pointer-evts">
                  <img :src="item.cover" :alt="item.title" />
                  <!-- <div class="video_time">{{ item.time }}</div> -->
                </div>
                <div class="video_intro-wrap no-pointer-evts">
                  <div class="video_title">{{ item.title }}</div>
                  <div class="info-wrap">
                    <span class="no">第{{ item.periods }}期</span>
                    &nbsp;
                    <span class="address">{{ item.city }}</span>
                    /
                    <span class="date">{{ item.date }}</span>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btn-wrap">
            <div class="activity swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="activity swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 现场 SWIPER END -->

      <!-- 万象 SWIPER START -->
      <div class="wanxiang-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">万象</div>
            <div class="subtitle">Far Beyond the Horizon</div>
          </div>
          <div class="more_btn" @click="onClickMore('wanxiang')">查看全部</div>
        </div>
        <div class="wanxiang-swiper-bl">
          <swiper class="swiper" :options="wanxiangSwiperOption">
            <swiper-slide v-for="album in wanxiangList" :key="album.id">
              <div class="swiper-page">
                <div class="wanxiang-item first" @click.stop="gotoWanXiangDetail(album)">
                  <div class="cover-wrap">
                    <img :src="album.cover" :alt="album.title" />
                    <!-- <div class="video_time">{{ list[0].time }}</div> -->
                  </div>
                  <div class="wanxiang-intro-wrap">
                    <div class="video_title wanxiangfree_title">
						<div class="video_title_left">{{ album.title }}</div>	
						<div class="video_title_right" v-if="album.is_free_time == 1">
							<div class="freetips_title">限时免费</div>
							<div class="freetips_intro">
								<span>{{album.free_time_days}}</span>后恢复原价{{album.course_original_price}}元
							</div>
						</div>
					</div>
                    <div class="video_intro">
                      {{ album.intro }}
                    </div>
                  </div>
                </div>
                <div class="swiper-page-right-wrap" v-if="album.items && album.items.length">
                  <div v-for="item in album.items" class="wanxiang-item" :key="item.id" @click.stop="gotoWanXiangDetail(album, item.id)">
                    <div class="cover-wrap">
                      <img :src="item.cover" :alt="item.title" />
                      <div class="video_time">{{ item.time }}</div>
                    </div>
                    <div class="video_intro-wrap">
                      <div class="video_intro--content">
                        <div class="video_title">{{ item.title }}</div>
                        <div class="speaker_intro-wrap">
                          <span class="speaker_name">{{ item.speaker.name }}</span>
                          <span class="speaker_intro">{{ item.speaker.intro }}</span>
                        </div>
                        <div class="video_intro">
                          {{ item.titlelanguage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btn-wrap">
            <div class="wanxiang swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="wanxiang swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 万象 SWIPER END -->

      <!-- 枝桠 SWIPER START -->
      <div class="zhiya-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">枝桠</div>
            <div class="subtitle">自然生长</div>
          </div>
          <div class="more_btn" @click="onClickMore('zhiya')">查看全部</div>
        </div>
        <div class="zhiya-swiper-bl">
          <swiper class="swiper" :options="zhiyaSwiperOption" @click="onClickZhiYaItem">
            <swiper-slide v-for="item in zhiyaSwiperItems" :key="item.id">
              <div class="zhiya-item" :data-id="item.id" :data-episodeid="item.zhiya_video_id">
                <div class="cover-wrap no-pointer-evts">
                  <img :src="item.cover" />
				  <div class="memberTag_right" v-if="item.member_type == 2">会员专享</div>
                </div>
				<div class="video_intro-wrap no-pointer-evts">
				  <div class="video_intro--content">
				    <div class="video_title">{{ item.title }}</div>
				    <div class="speaker_intro-wrap">
				      <span class="speaker_name">{{ item.speaker.name }}</span>
				      <span class="speaker_intro">{{ item.speaker.intro }}</span>
				    </div>
				    <div class="video_intro">
				      {{ item.titlelanguage }}
				    </div>
				  </div>
				</div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btn-wrap">
            <div class="zhiya swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="zhiya swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 枝桠 SWIPER END -->

      <!-- 记录 SWIPER START -->
      <div class="record-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">记录</div>
            <div class="subtitle">生命广阔</div>
          </div>
          <div class="more_btn" @click="onClickMore('record')">查看全部</div>
        </div>
        <div class="record-swiper-bl">
          <swiper class="swiper" :options="recordSwiperOption" @click.stop="onClickRecordItem">
            <swiper-slide v-for="item in recordSwiperItems" :key="item.id">
              <div class="record-item" :data-id="item.id">
                <div class="cover-wrap no-pointer-evts">
                  <img :src="item.cover" :alt="item.title" />
                  <div class="video_time">{{ item.time }}</div>
				  <div class="memberTag" v-if="item.member_type == 2">会员专享</div>
                </div>
                <div class="video_intro-wrap no-pointer-evts">
                  <div class="video_intro--content">
                    <div class="video_title">{{ item.title }}</div>
                    <div class="speaker_intro-wrap">
                      <span class="speaker_name">{{ item.speaker.name }}</span>
                      <span class="speaker_intro">{{ item.speaker.intro }}</span>
                    </div>
                    <div class="video_intro">
                      {{ item.titlelanguage }}
                    </div>
                  </div>
                </div>
              
			  </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btn-wrap">
            <div class="record swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="record swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 记录 SWIPER END -->


      <!-- 资讯 SWIPER START -->
      <!-- <div class="record-bl">
        <div class="title-bl">
          <div class="title-wrap">
            <div class="title">资讯</div>
            <div class="subtitle">一席讲者</div>
          </div>
          <div class="more_btn" @click="onClickMore('record')">查看全部</div>
        </div>
        <div class="record-swiper-bl">
          <swiper class="swiper" :options="recordSwiperOption" @click.stop="onClickRecordItem">
            <swiper-slide v-for="item in recordSwiperItems" :key="item.id">
              <div class="record-item" :data-id="item.id">
                <div class="cover-wrap no-pointer-evts">
                  <img :src="item.cover" :alt="item.title" />
                  <div class="video_time">{{ item.time }}</div>
				  <div class="memberTag" v-if="item.member_type == 2">会员专享</div>
                </div>
                <div class="video_intro-wrap no-pointer-evts">
                  <div class="video_intro--content">
                    <div class="video_title">{{ item.title }}</div>
                    <div class="speaker_intro-wrap">
                      <span class="speaker_name">{{ item.speaker.name }}</span>
                      <span class="speaker_intro">{{ item.speaker.intro }}</span>
                    </div>
                    <div class="video_intro">
                      {{ item.titlelanguage }}
                    </div>
                  </div>
                </div>
              
			  </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-btn-wrap">
            <div class="record swiper-btn-prev swiper-btn">
              <i class="iconfont iconarrow_left"></i>
            </div>
            <div class="record swiper-btn-next swiper-btn">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 资讯 SWIPER END -->

      
    </div>
  </div>
</template>

<script>
import HomeBanner from '@/components/TheHomeBanner';
import requestApi from '@/service';

// 演讲swiper常量
const SPEECH_SWIPER_PAGE_SIZE = 12; // 演讲一页展示个数
const SPEECH_SWIPER_PAGE_ROW = 3; // 演讲一页展示行数
const SPEECH_SWIPER_ITEM_HEIGHT = 256; // 演讲单个模块高度
const SPEECH_SWIPER_ITEM_GAP = 20; // 演讲模块间距
// 现场swiper常量
const ACTIVITY_SWIPER_PAGE_SIZE = 4; // 一页展示个数
// 万象swiper常量
// const WANXIANG_SWIPER_PAGE_SIZE = 5; // 一页展示个数
// 枝桠swiper常量
const ZHIYA_SWIPER_PAGE_SIZE = 3; // 一页展示个数
// 记录swiper常量
const RECORD_SWIPER_PAGE_SIZE = 4; // 一页展示个数

export default {
  name: 'Home',
  components: {
    HomeBanner,
  },
  data() {
    return {
      banners: [],
      // swiper options
      speechSwiperOption: {
        navigation: {
          prevEl: '.speech.swiper-btn-prev',
          nextEl: '.speech.swiper-btn-next',
        },
      },
      // speech parmas 演讲
      speechSwiperPages: [], // 演讲swiper页数组
      speechPageNum: 1,
      speechSize: 24,
      speechTotal: 0,
      ssbsIndex: 0, // 演讲按钮上下滚动index
      SPEECH_SWIPER_ITEM_HEIGHT,
      SPEECH_SWIPER_ITEM_GAP,
      // activity params 现场
      activitySwiperOption: {
        slidesPerView: ACTIVITY_SWIPER_PAGE_SIZE,
        slidesPerGroup: ACTIVITY_SWIPER_PAGE_SIZE,
        spaceBetween: 20,
        navigation: {
          prevEl: '.activity.swiper-btn-prev',
          nextEl: '.activity.swiper-btn-next',
        },
      },
      activitySwiperItems: [], // 现场swiper页数组
      activityTotal: 0,
      activityPageNum: 1,
      activitySize: 12,
      // wanxiang params 万象
      wanxiangSwiperOption: {
        navigation: {
          prevEl: '.wanxiang.swiper-btn-prev',
          nextEl: '.wanxiang.swiper-btn-next',
        },
      },
      wanxiangList: [],
      wanxiangPageNum: 1,
      wanxiangSize: 15,
      wanxiangTotal: 0,
      // zhiya 枝桠
      zhiyaSwiperOption: {
        slidesPerView: ZHIYA_SWIPER_PAGE_SIZE,
        slidesPerGroup: ZHIYA_SWIPER_PAGE_SIZE,
        spaceBetween: 20,
        navigation: {
          prevEl: '.zhiya.swiper-btn-prev',
          nextEl: '.zhiya.swiper-btn-next',
        },
      },
      zhiyaSwiperItems: [], // 现场swiper数组
      zhiyaTotal: 0,
      zhiyaPageNum: 1,
      zhiyaSize: 9,
      // record 记录
      recordSwiperOption: {
        slidesPerView: RECORD_SWIPER_PAGE_SIZE,
        slidesPerGroup: RECORD_SWIPER_PAGE_SIZE,
        spaceBetween: 20,
        navigation: {
          prevEl: '.record.swiper-btn-prev',
          nextEl: '.record.swiper-btn-next',
        },
      },
      recordSwiperItems: [], // 现场swiper数组
      recordTotal: 0,
      recordPageNum: 1,
      recordSize: 12,
    };
  },
  mounted() {
    this._addEvent();
    this.speechSwiperPages = [];
  },
  beforeDestroy() {
    this._removeEvent();
  },
  created() {
    this.getBanners();
    this.getSpeechData();
    this.getActivityData();
    this.getWanXiangData();
    this.getZhiYaData();
    this.getRecordData();
  },
  methods: {
    _addEvent() {
      window.addEventListener('scroll', this._scrollEvent);
    },
    _removeEvent() {
      window.removeEventListener('scroll', this._scrollEvent);
    },
    /**
     * @description: 监听滚动事件 用来对模块右侧翻页按钮进行动态定位
     */
    _scrollEvent() {
      if (this.scrollTimer) {
        return;
      }
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;
        const topBarH = document.getElementsByClassName('top_bar-base')[0].offsetHeight;
        const ssbt = this.$refs.speechSwiperBtns.getBoundingClientRect().top; // speech swiper btns wrap top 演讲翻页按钮距离顶部距离
        // 计算出步进粒度
        const n = Math.round(Math.abs(ssbt - topBarH) / (SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP));
        const max = SPEECH_SWIPER_PAGE_ROW - 1;
        if (ssbt - topBarH < 0 && this.ssbsIndex < SPEECH_SWIPER_PAGE_ROW) {
          this.ssbsIndex += n > max ? max : n;
          this.ssbsIndex = this.ssbsIndex > max ? max : this.ssbsIndex;
        } else if (ssbt - topBarH > SPEECH_SWIPER_ITEM_HEIGHT + SPEECH_SWIPER_ITEM_GAP && this.ssbsIndex > 0) {
          this.ssbsIndex -= n > max ? max : n;
          this.ssbsIndex = this.ssbsIndex < 0 ? 0 : this.ssbsIndex;
        }
      }, 500);
    },
    getBanners() {
      requestApi('/v3/api/site/banner/').then(data => {
        this.banners = data.items;
      });
    },
    /**
     * @description: 获取演讲列表
     */
    getSpeechData() {
      requestApi('/v3/api/site/speech/', {
        page: this.speechPageNum,
        page_size: this.speechSize,
      }).then(res => {
        if (this.speechPageNum === 1) {
          this.speechSwiperPages = this.handleData(res.items, SPEECH_SWIPER_PAGE_SIZE);
		  
          this.speechTotal = res.total;
        } else {
          this.speechSwiperPages = this.speechSwiperPages.concat(this.handleData(res.items, SPEECH_SWIPER_PAGE_SIZE));
        }
		console.log(this.speechSwiperPages)
      });
    },
    /**
     * @description: 获取现场
     */
    getActivityData() {
      requestApi('/v3/api/site/activity/', {
        page: this.activityPageNum,
        page_size: this.activitySize,
      }).then(res => {
        if (this.activityPageNum === 1) {
          this.activitySwiperItems = res.items;
		  console.log(this.activitySwiperItems)
          this.activityTotal = res.total;
        } else {
          this.activitySwiperItems = this.activitySwiperItems.concat(res.items);
		  console.log(this.activitySwiperItems)
        }
      });
    },
    /**
     * @description: 获取万象
     */
    getWanXiangData() {
      requestApi('/v3/api/site/wanxiang/', {
        page: this.wanxiangPageNum,
        page_size: this.wanxiangSize,
      }).then(res => {
        if (this.wanxiangPageNum === 1) {
          this.wanxiangList = res.items;
          this.wanxiangTotal = res.total;
        } else {
          this.wanxiangList = this.wanxiangList.concat(res.items);
        }
      });
    },
    getZhiYaData() {
      requestApi('/v3/api/site/zhiya/', {
        page: this.zhiyaPageNum,
        page_size: this.zhiyaSize,
      }).then(res => {
        if (this.zhiyaPageNum === 1) {
          this.zhiyaSwiperItems = res.items;
          this.zhiyaTotal = res.total;
        } else {
          this.zhiyaSwiperItems = this.zhiyaSwiperItems.concat(res.items);
        }
      });
    },
    getRecordData() {
      requestApi('/v3/api/site/record/', {
        page: this.recordPageNum,
        page_size: this.recordSize,
      }).then(res => {
        if (this.recordPageNum === 1) {
          this.recordSwiperItems = res.items;
          this.recordTotal = res.total;
        } else {
          this.recordSwiperItems = this.recordSwiperItems.concat(res.items);
        }
      });
    },
    handleData(data, size) {
      const list = [];
      while (data.length > 0) {
        list.push(data.splice(0, size));
      }
      return list;
    },
    cutWanXiangData(arr) {
      return arr.slice(1);
    },
    /**
     * @description: 查看全部按钮
     */
    onClickMore(type) {
      this.$router.push(`/${type}`);
    },
    /**
     * @description: 事件委托 演讲点击
     */
    onClickSpeechItem(e) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id: e.target.dataset.id,
        },
      });
    },
    onClickActivityItem(e) {
      this.$router.push({
        path: '/activity/detail',
        query: {
          id: e.target.dataset.id,
        },
      });
    },
    /**
     * @description: 万象专辑
     */
    gotoWanXiangDetail(data, episodeId) {
      this.$router.push({
        path: '/wanxiang/detail',
        query: {
          id: data.id,
          episodeId: episodeId || (data.items.length && data.items[0].id),
          isColumn: episodeId === undefined ? 1 : 0,
        },
      });
    },
    /**
     * @description: 枝桠 事件委托
     */
    onClickZhiYaItem(e) {
      this.$router.push({
        path: '/zhiya/detail',
        query: {
          id: e.target.dataset.id,
          episodeId: e.target.dataset.episodeid,
        },
      });
    },
    onClickRecordItem(e) {
      const id = e.target.dataset.id;
      this.$router.push({
        path: '/record/detail',
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  width: 100%;
  box-sizing: border-box;
  .content {
    .speech-bl,
    .activity-bl,
    .wanxiang-bl,
    .zhiya-bl,
    .record-bl {
      width: 100%;
      margin-bottom: 20px;
      .title-bl {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 17px 0;
        .title-wrap {
          .title {
            font-size: 25px;
            color: $C6;
            font-family: HYXinRenWenSongW;
            display: inline-block;
          }
          .subtitle {
            font-size: 12px;
            color: $C9;
            font-weight: 300;
            letter-spacing: 4px;
            margin-left: 10px;
            display: inline-block;
          }
        }
        .more_btn {
          font-size: 12px;
          color: $C3;
          font-weight: 300;
          margin-top: 10px;
          display: inline-block;
          cursor: pointer;
          &:hover {
            color: $C7;
          }
        }
      }
    }
    .zhiya-bl,
    .record-bl {
      .title-wrap .subtitle {
        letter-spacing: 4px;
      }
    }
  }
  .speech-swiper-bl,
  .activity-swiper-bl,
  .wanxiang-swiper-bl,
  .zhiya-swiper-bl,
  .record-swiper-bl {
    position: relative;
  }
  .activity-swiper-bl .swiper {
    padding-bottom: 10px;
  }
  .swiper {
    margin-left: auto;
    margin-right: auto;
    .swiper-slide {
      .swiper-page {
        margin: -10px;
        width: calc(100% + 20px);
        height: 100%;
      }
      .speech-item,
      .wanxiang-item {
        display: inline-block;
        vertical-align: bottom;
        width: calc(25% - 20px);
        height: 256px;
        max-height: 256px;
        max-width: 270px;
        overflow: hidden;
        margin: 10px;
      }
      .speech-item,
      .activity-item,
      .wanxiang-item,
      .zhiya-item,
      .record-item {
        position: relative;
        background-color: $C9;
        cursor: pointer;
        .cover-wrap {
          height: 160px;
          width: 100%;
          overflow: hidden;
          position: relative;
          & > img {
            width: 100%;
            height: 100%;
            vertical-align: bottom;
            object-fit: cover;
          }
          .video_time {
            color: $C1;
            font-size: 12px;
            background: $A1;
            width: 56px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-weight: 100;
          }
        }
        .video_intro-wrap {
          width: 100%;
          height: 96px;
          background-color: $C1;
          padding: 20px;
          box-sizing: border-box;
          overflow: hidden;
          .video_title {
            color: $C6;
            font-size: 16px;
            line-height: 17px;
            font-family: HYXinRenWenSongW;
          }
        }
      }
      .activity-item {
        transition: box-shadow 0.3s ease;
        .video_intro-wrap {
          .video_title {
            min-height: 40px;
          }
          .info-wrap {
            font-size: 12px;
            margin: 10px auto 0;
            font-weight: 200;
            margin-bottom: 2px;
            color: $C4;
            line-height: 12px;
          }
        }
        &:hover {
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        }
      }
      .speech-item,
      .wanxiang-item,
	  .zhiya-item,
      .record-item {
        height: 256px;
        .video_intro-wrap {
          position: absolute;
          bottom: 0;
          left: 0;
          transition: height 0.3s ease-out;
          .video_intro--content {
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
          .speaker_intro-wrap {
            font-size: 12px;
            margin: 10px auto 2px;
            font-weight: 200;
            color: $C4;
            line-height: 12px;
            .speaker_name {
              margin-right: 10px;
            }
          }
          .video_intro {
            margin-top: 18px;
            font-size: 14px;
            color: $C6;
            line-height: 21px;
            font-weight: 300;
            font-family: 'PingFangSC-Light';
            max-height: 128px;
            overflow: hidden;
            opacity: 0;
          }
          .speaker_intro-wrap .speaker_intro,
          .video_intro {
            opacity: 0;
            transition: opacity 0.3s ease;
          }
        }
        &:hover {
          .video_intro-wrap {
            height: 100%;
            .speaker_intro-wrap {
              color: $C7;
              font-weight: 400;
            }
            .speaker_intro,
            .video_intro {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .wanxiang-swiper-bl {
    .swiper {
      padding-bottom: 5px;
    }
    .swiper-page {
      .wanxiang-item.first {
        max-width: unset;
        width: calc(50% - 10px);
        height: 532px;
        max-height: 532px;
        transition: box-shadow 0.3s ease;
        .cover-wrap {
          height: 396px;
        }
        .wanxiang-intro-wrap {
          height: 136px;
          position: static;
          background-color: $C1;
          padding: 20px;
          box-sizing: border-box;
          .video_title {
            color: $C6;
            font-size: 16px;
            line-height: 17px;
            font-family: HYXinRenWenSongW;
          }
          .video_intro {
            margin-top: 18px;
            font-size: 14px;
            color: $C6;
            line-height: 21px;
            font-weight: 300;
            font-family: 'PingFangSC-Light';
          }
        }
        &:hover {
          box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        }
      }
      &-right-wrap {
        display: inline-flex;
        flex-wrap: wrap;
        margin: -10px;
        height: 100%;
        padding: 10px;
        width: calc(50% - 10px);
        vertical-align: top;
        .wanxiang-item {
          width: calc(50% - 20px);
        }
      }
    }
  }
  .zhiya-swiper-bl {
    .swiper {
      padding-bottom: 5px;
      .zhiya-item {
		  width: 100%;
        // width: calc((100% - 60px) / 3 - 0px);
        // max-width: 372px;
        height: 312px;
        display: inline-block;
        vertical-align: bottom;
        transition: box-shadow 0.3s ease;
        // &:hover {
        //   box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
        // }
        .cover-wrap {
          height: 216px;
          width: 100%;
        }
      }
    }
  }
}
.wanxiangfree_title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	.video_title_right {
		color: #CA644A;
		display: flex;
		align-items: center;
		font-family: 'PingFang SC';
		.freetips_title {
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			margin-right: 10px;
		}
		.freetips_intro {
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			padding: 2px 8px;
			border-radius: 2px;
			background: #FFEEE4;
		}
	}
}
</style>
